import React from "react";

/**
 * "Verified" badge — the business completed identity verification with our
 * payment provider and is active on BookFreely. It is NOT a quality guarantee,
 * so the tooltip spells out exactly what was verified.
 */
export default function VerifiedBadge({ size = "sm", label = "Verified", className = "" }) {
  const sizes = {
    xs: { pad: "px-2 py-0.5", text: "text-[10px]", icon: 10 },
    sm: { pad: "px-2.5 py-1", text: "text-xs", icon: 12 },
    md: { pad: "px-3 py-1.5", text: "text-sm", icon: 14 },
  };
  const dim = sizes[size] || sizes.sm;
  return (
    <span
      data-testid="verified-badge"
      title="This business completed identity verification with our payment provider. BookFreely does not guarantee the service itself."
      className={`inline-flex items-center gap-1.5 rounded-full font-medium tracking-wide ${dim.pad} ${dim.text} ${className}`}
      style={{
        background: "var(--gf-accent)",
        color: "var(--gf-on-accent)",
        boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
      }}
    >
      <svg width={dim.icon} height={dim.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M9 12l2 2 4-4" />
        <path d="M12 2l2.5 2 3.2-.5L19 6.7l2.4 2.1-1 3.2 1 3.2L19 17.3l-.3 3.2-3.2-.5L12 22l-2.5-2-3.2.5L5 17.3 2.6 15.2 3.6 12 2.6 8.8 5 6.7l.3-3.2 3.2.5L12 2z" />
      </svg>
      {label}
    </span>
  );
}
